import './Styles.css';
import React, { useState, useEffect, useCallback } from "react";
import {Button, Select, Switch, MenuItem, TextField, FormGroup, FormControlLabel, FormControl, } from '@mui/material';
import { NewBroadcastMessage } from './new_broadcastmessage';
import { NewScreenDisplay } from './new_screendisplay';

export const Forms = ({apiConfig, onSubmit, onCancel, editAIObject, aiobjects}) => {
    const initialInputState = {
      ObjectClass: "", AllowBroadcast:false, AllowScreenDisplay:false, Priority:0,
      GPTSystemPrompt:"", GPTPrompt:"", BroadcastMessageId:"", ScreenDisplayId: "", CreatedBy: "system", UpdatedBy: "system"};
    const [eachEntry, setEachEntry] = useState(initialInputState);
    const {ObjectClass, AllowBroadcast, AllowScreenDisplay, Priority, GPTSystemPrompt, GPTPrompt, BroadcastMessageId, ScreenDisplayId} = eachEntry;
    const [createBroadcastMessageOpen, setCreateBroadcastMessageOpen]=useState(false);
    const [createScreenDisplayOpen, setCreateScreenDisplayOpen]=useState(false);
    const [broadcastMessages, setBroadcastMessages] = useState([])
    const [screenDisplays, setScreenDisplays] = useState([])
    // const [nameError, setNameError] = useState(false);

  console.log(eachEntry);

  const getBroadcastMessagesAndScreenDisplay = useCallback(() => {
    Promise.all([
      apiConfig.fetchAllAIBroadcasts(),
      apiConfig.fetchAllAIScreenDisplays()
      // apiConfig.fetchRobotStatus(robot_info.Id),
    ]).then(results => {
      setBroadcastMessages(results[0].RobotResponse);
      setScreenDisplays(results[1].RobotResponse);
    }).catch(error => {
      console.error(error);
    });
  }, [apiConfig]);

  // updating eachEntry each time editEndpoint changes
  useEffect(() => {
    getBroadcastMessagesAndScreenDisplay();
    if (editAIObject) {
      setEachEntry(editAIObject);
      console.log('changed');
    }
  }, [editAIObject, getBroadcastMessagesAndScreenDisplay]);

  // handling input changes - can set errors here
  const handleInputChange = (e) => {
    setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
  //   const arrAIObjectNames = !editAIObject
  // ? aiobjects.map(aiobject => aiobject.Name)
  // : aiobjects.map(aiobject => aiobject.Name).filter(name => name !== editAIObject.Name);

  //   console.log(arrAIObjectNames)
  //   // prevent same endpoint name
  //   console.log(editAIObject);
  //  if (e.target.name === 'Name' && arrAIObjectNames.includes(e.target.value)){
  //   setNameError(true);
  //  }
  //  else{
  //   setNameError(false);
  //  }
  };

  // handling switch changes
  const handleSwitchChange = (e) => {
    setEachEntry({ ...eachEntry, [e.target.name]: e.target.checked });
  }

  // handling submit
  const handleFinalSubmit = (e) => {
    e.preventDefault();
    onSubmit(eachEntry);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    onCancel(editAIObject);
    setEachEntry(initialInputState);
  }

  return (
    <div className="formContainer">
      <hr style={{width: '100%',marginTop: '2%' }}/>
      <div className="submitButton">
        {editAIObject ? <h1>Edit AI Object</h1> : <h1>Create New AI Object</h1>}
        <div className='TopButtons'>
          <Button onClick={handleCancel}>CANCEL</Button>
          <Button onClick={handleFinalSubmit}>SUBMIT</Button>
        </div>
      </div>
        <FormControl component="fieldset" className="formGroup">
            <FormGroup className="formGroup">
              <div className="formInput">
                <label>Object</label>
                <TextField
                name="ObjectClass"
                value={ObjectClass}
                onChange={handleInputChange}
                />
              </div>
              <div className="formInput">
                <label>Allow Broadcast</label>
                <FormControlLabel
                  control={
                    <Switch
                    checked={AllowBroadcast}
                    onChange={handleSwitchChange}
                    name="AllowBroadcast"
                    color='primary'
                  />}
                />
              </div>
              <div className="formInput">
                <label>Allow Screen Display</label>
                <FormControlLabel
                  control={
                    <Switch
                    checked={AllowScreenDisplay}
                    onChange={handleSwitchChange}
                    name="AllowScreenDisplay"
                    color='primary'
                  />}
                />
              </div>
              <div className="formInput">
                <label>Priority</label>
                <TextField
                  name="Priority"
                  type="number"
                  value={Priority}
                  onChange={handleInputChange}
                  InputProps={{ inputProps: { min: 0 } }}
                />
              </div>
              <div className="formInput">
                <label>GPT System Prompt</label>
                <TextField
                  name="GPTSystemPrompt"
                  value={GPTSystemPrompt}
                  onChange={handleInputChange}
                />
              </div>
              <div className="formInput">
                <label>GPT Prompt</label>
                <TextField
                name="GPTPrompt"
                value={GPTPrompt}
                onChange={handleInputChange}
                />
              </div>
              <div className="formInput">
                <label>Broadcast Message</label>
                <FormControl>
                <Select
                  name="BroadcastMessageId"
                  value={BroadcastMessageId}
                  onChange={handleInputChange}>
                      <MenuItem value={""} onClick={()=>{setCreateBroadcastMessageOpen(true)}}>
                          <em>Create New</em>
                      </MenuItem>
                      {broadcastMessages.map((message, index)=>{
                          return(
                            <MenuItem key={index} value={message.Id}>
                                {message.BroadcastMessage}
                            </MenuItem>
                          )
                      })}
                  </Select>
                </FormControl>
              </div>
              <div className="formInput">
              <label>Screen Display</label>
                <FormControl>
                <Select
                  name="ScreenDisplayId"
                  value={ScreenDisplayId}
                  onChange={handleInputChange}>
                      <MenuItem value={""} onClick={()=>{setCreateScreenDisplayOpen(true)}}>
                          <em>Create New</em>
                      </MenuItem>
                      {screenDisplays.map((display, index)=>{
                          return(
                            <MenuItem key={index} value={display.Id}>
                                {display.ScreenName}
                            </MenuItem>
                          )
                      })}
                  </Select>
                </FormControl>
              </div>
            </FormGroup>
            {createBroadcastMessageOpen && <NewBroadcastMessage apiConfig={apiConfig} open={createBroadcastMessageOpen} onClose={() => setCreateBroadcastMessageOpen(false)} onSubmit={newBroadcastMessage=>{console.log(newBroadcastMessage); setCreateBroadcastMessageOpen(false)}}/>}
            {createScreenDisplayOpen && <NewScreenDisplay apiConfig={apiConfig} open={createScreenDisplayOpen} onClose={() => setCreateScreenDisplayOpen(false)} onSubmit={newScreenDisplay=>{console.log(newScreenDisplay); setCreateScreenDisplayOpen(false)}}/>}
        </FormControl>
    </div>
  );
};

export default Forms;